export const config = {
  title: "Butler Bookeeping LLC",
  meta: {
    description:
      "Butler Bookeeping LLC offers expert bookkeeping tailored for small businesses in Cupertino, CA, supporting accurate records, payroll, and financial clarity.",
    keywords: [
      "Butler Bookeeping LLC",
      "Cupertino bookkeeping",
      "small business bookkeeper CA",
      "payroll services Cupertino",
      "accounting support Cupertino"
    ],
    author: "Butler Bookeeping LLC",
    canonicalUrl: "https://butlerbkg.com/",
  },
  sections: {
    header: {
      businessName: "Butler Bookeeping LLC",
    },
    sectionB: {
      heroTitle: "Butler Bookeeping LLC",
      heroSubtitle: "Small Business Bookkeeping & Payroll in Cupertino, CA",
      learnAboutText: "Learn About Our Services",
      phoneNumber: "4089316464",
      phoneLabel: "(408) 931‑6464",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1589980410/photo/hands-accountant-and-woman-with-document-for-finance-tax-or-audit-in-business-office.jpg?s=612x612&w=0&k=20&c=cEah1lFMKgHBdIl1ygISkZChyi0FFzrBkP4yOMRMM_A=",
      cardData: [
        {
          title: "Bookkeeping Services",
          description:
            "Accurate records and financial statements customized for your business.",
        },
        {
          title: "Payroll Services",
          description:
            "Reliable payroll processing and tax filing support.",
        },
        {
          title: "Startup Support",
          description:
            "Onboarding support for recording, organization, and setup.",
        },
      ],
      description:
        "Based in Cupertino, CA, Butler Bookeeping LLC provides comprehensive bookkeeping and payroll services tailored to small businesses and startups for financial organization and growth.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "We support startups and small businesses with bookkeeping, payroll, and financial recordkeeping.",
      cards: [
        {
          title: "Monthly Bookkeeping",
          description:
            "Clean ledger maintenance, reconciliations, and monthly reporting.",
          imageSrc: "https://media.istockphoto.com/id/1330234567/photo/closeup-shot-of-an-unrecognisable-businesswoman-calculating-finances-in-an-office.jpg?s=612x612&w=0&k=20&c=XCBeNRCTVXdujWGnByiMyr4DmoYV8yME8H08kaiI8Hw=",
          imageAlt: "Bookkeeping",
        },
        {
          title: "Payroll Management",
          description:
            "Employee payroll, tax filings, benefits deductions—handled smoothly.",
          imageSrc: "https://media.istockphoto.com/id/637850838/photo/accounting.jpg?s=612x612&w=0&k=20&c=8SIQ_ZpjYu9I684s_5MTfa7uWYFxkIy1aEYXKv58kyg=",
          imageAlt: "Payroll Services",
        },
        {
          title: "Startup Setup",
          description:
            "Account setup, chart of accounts, and onboarding guidance.",
          imageSrc: "https://media.istockphoto.com/id/1453639790/photo/closeup-group-of-asian-business-people-meeting-discuss-project-plan-and-financial-results-in.jpg?s=612x612&w=0&k=20&c=qomjWk2hhBtGDFThUEshjayr-_OP8jq-qUf8PnsQpaE=",
          imageAlt: "Startup Setup",
        },
      ],
      otherServicesTitle: "Additional Support",
      otherServicesList: [
        "QuickBooks Setup & Training",
        "Financial Reporting & Dashboarding",
        "Sales Tax Filing",
        "Consulting on Recordkeeping",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://media.istockphoto.com/id/1330234606/photo/closeup-shot-of-an-unrecognisable-businesswoman-calculating-finances-in-an-office.jpg?s=612x612&w=0&k=20&c=Mx0e58QqTPyrmjmP8zi4nApJg9jw3sHZCbE1RwJEeyQ=",
        alt: "Butler Bookeeping Team",
      },
      aboutText: [
        "Butler Bookeeping LLC is a locally trusted financial partner in Cupertino, CA, helping small businesses keep accurate records and stay compliant.",
        "Our mission: streamline financial operations so you can focus on growing your business.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Butler Bookeeping Logo",
      businessName: "Butler Bookeeping LLC",
      contact: {
        phone: "4089316464",
        phoneLabel: "(408) 931‑6464",
        email: "damianb@butlerbkg.com",
        website: "https://butlerbkg.com/",
        address: "19130 Loree Ave, Cupertino, CA 95014",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "19130 Loree Ave, Cupertino, CA 95014",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3169.123456789!2d-122.0325476!3d37.3229981!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fcb0b1234567b%3A0xabcdef9876543210!2s19130+Loree+Ave%2C+Cupertino%2C+CA+95014!5e0!3m2!1sen!2sus!4v1718658000000!5m2!1sen!2sus",
    },
  },
};

export default config;
